import { render } from "./AnnouncementPanel.vue?vue&type=template&id=39096aff"
import script from "./AnnouncementPanel.vue?vue&type=script&lang=js"
export * from "./AnnouncementPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__